import "./RowLayout.scss";

export default function RowLayout({ children }) {
  return <div className="form-name-container">{children}</div>;
}
